module.exports = __webpack_public_path__ + "img/signup-bg1.09f72b07.png";